import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export default () => {
  const { t } = useI18n();

  const customTimeslotsSchema = yup.array().of(
    yup.object({
      start_time: yup.string().required(),
      end_time: yup.string().required(),
      destinations: yup.array().of(yup.string()).min(1),
    }),
  );

  const dropOffSchema = yup.object({
    mode: yup.string().nullable(),
    custom_timeslots: customTimeslotsSchema,
    show_single_timeslot: yup.boolean().nullable(),
    show_instructions: yup.boolean().nullable(),
    runner_app_enabled: yup.boolean().nullable(),
    fee: yup
      .number()
      .nullable()
      .optional()
      .max(99.99, t('errorMessages.lessThan', { lessThan: '$100' })),
  });

  const businessUnitSchema = yup.object({
    id: yup.string().nullable().optional(),
    name: yup.string().required(t('errorMessages.required')),
    meta: yup.object({
      unit: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .typeError(t('errorMessages.invalidNumber'))
        .required(t('errorMessages.required')),
      jde_environment: yup.string().nullable(),
    }),
    market_place: yup.object({
      is: yup.object({
        enabled: yup.boolean().nullable(),
      }),
      label: yup
        .object()
        .nullable()
        .when(`is.enabled`, {
          is: true,
          then: yup.object({
            en: yup.string().required(t('errorMessages.required')).nullable(),
            fr: yup.string().nullable(),
          }),
          otherwise: yup.object({
            en: yup.string().nullable().optional(),
            fr: yup.string().nullable().optional(),
          }),
        }),
      location_description: yup
        .object()
        .nullable()
        .when(`is.enabled`, {
          is: true,
          then: yup.object({
            en: yup.string().required(t('errorMessages.required')),
            fr: yup.string().nullable(),
          }),
          otherwise: yup.object({
            en: yup.string().nullable().optional(),
            fr: yup.string().nullable().optional(),
          }),
        }),
      pickup_instruction: yup
        .object()
        .nullable()
        .when(`is.enabled`, {
          is: true,
          then: yup.object({
            en: yup
              .string()
              .required(t('errorMessages.required'))
              .max(200, t('errorMessages.max', { count: 200 })),
            fr: yup
              .string()
              .nullable()
              .max(200, t('errorMessages.max', { count: 200 })),
          }),
          otherwise: yup.object({
            en: yup
              .string()
              .nullable()
              .optional()
              .max(200, t('errorMessages.max', { count: 200 })),
            fr: yup
              .string()
              .nullable()
              .optional()
              .max(200, t('errorMessages.max', { count: 200 })),
          }),
        }),
      logo: yup.string().nullable(),
    }),
    // The slot rule only applies while Marketplace is on. With it off the drop-off fields are
    // disabled and not saved, so a stored custom mode with no windows (Location drops windows
    // whose spots were deleted) must not block the rest of the form.
    drop_off: dropOffSchema.when('market_place', {
      is: (marketPlace?: { is?: { enabled?: boolean } }) => !!marketPlace?.is?.enabled,
      then: dropOffSchema.shape({
        custom_timeslots: customTimeslotsSchema.when('mode', {
          is: 'custom',
          then: yup
            .array()
            .min(1, t('sites.businessUnit.form.marketplace.dropOff.customTimeslots.required')),
        }),
      }),
    }),
  });

  return {
    businessUnitSchema,
  };
};
